<template>
  <div>
    <router-view></router-view>
    <b-modal header-class="releaseNote" v-model="updatesAvailable" centered ref="update-modal" id="bv-modal-example" hide-footer>
    <template #modal-title style="background:green">
      <p class="m-0 p-0" style="color:green">We just upgraded to v8.0.1
        <b-badge variant="danger">Important</b-badge>
      </p>
    </template>
      <p><strong>Version 8.0.1</strong></p>
      <p style="font-size:13px;color:gray" class="m-0 p-0">Yippie, we have just upgraded to a newer version with exciting features.</p>
      <p class="my-2">There are some important updates you should probably have a look at, recommend to kindly check thoroughly.</p>
      <div class="mt-2 text-center">
        <b-button variant="primary" class="mt-3" @click="seeUpdate">View Full Release Note</b-button>
      </div>
  </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return{
      updatesAvailable: false
    }
  },
  mounted() {
    var updates = JSON.parse(localStorage.getItem('v8.0.1'))
    if(updates){
      this.updatesAvailable = false
    }else{
      this.updatesAvailable = true
    }
    
  },
  methods: {
    seeUpdate(){
      localStorage.setItem('v8.0.1', JSON.stringify({seen: true}))
      this.updatesAvailable = false
      this.$router.push('/releaseNote')
    }
  }
}
</script>

<style scoped>
</style>